var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlayOutline = function SvgPlayOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.44 13.1802L6.00005 20.9202C5.78984 21.028 5.55537 21.0797 5.31931 21.0704C5.08324 21.0611 4.85357 20.9911 4.65249 20.8671C4.4514 20.7431 4.28571 20.5693 4.17141 20.3626C4.05712 20.1558 3.9981 19.9231 4.00005 19.6868V4.21349C4.00318 3.98335 4.06383 3.75766 4.17647 3.55694C4.2891 3.35623 4.45015 3.18687 4.64495 3.06429C4.83975 2.94172 5.06212 2.86981 5.29181 2.85511C5.5215 2.84042 5.75121 2.8834 5.96005 2.98016L21.44 10.7202V10.7135C21.4409 10.7139 21.4418 10.7144 21.4427 10.7148C21.4462 10.7166 21.4497 10.7184 21.4532 10.7202C21.6761 10.8351 21.8636 11.0086 21.9954 11.2222C22.1298 11.44 22.2009 11.6909 22.2009 11.9468C22.2009 12.2027 22.1298 12.4536 21.9954 12.6714C21.9949 12.6723 21.9943 12.6732 21.9938 12.6741C21.8595 12.8906 21.6678 13.0658 21.44 13.1802ZM5.50005 4.42721L20.5462 11.9503L5.50005 19.4929V4.42721Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlayOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play-outline.932354d9.svg";
export { ForwardRef as ReactComponent };